import { Timestamp } from "firebase/firestore";

export interface DiscountCode {
  id: string;
  active: boolean;
  type: "percentage" | "amount";
  name: string;
  value: number;
  startsAt: Timestamp;
  expiresAt: Timestamp;
  createdAt: Timestamp;
}

export interface DiscountGroup {
  id: string;
  codes: DiscountCode[];
}

function timestampFromCallableField(value: unknown): Timestamp {
  if (typeof value === "string") {
    const d = new Date(value);
    return Timestamp.fromDate(
      Number.isNaN(d.getTime()) ? new Date(0) : d,
    );
  }
  if (
    value &&
    typeof value === "object" &&
    typeof (value as { seconds?: unknown }).seconds === "number"
  ) {
    const o = value as { seconds: number; nanoseconds?: number };
    return new Timestamp(o.seconds, o.nanoseconds ?? 0);
  }
  return Timestamp.fromMillis(0);
}

/**
 * Maps `onlineOrdering-getDiscountByCode` JSON (ISO timestamps) into cart `DiscountCode`.
 */
export function discountFromCallablePayload(
  raw: Record<string, unknown> | null | undefined,
): DiscountCode | null {
  if (!raw) return null;

  const name =
    String(raw.name ?? raw.code ?? "").trim();
  const id = String(raw.id ?? name).trim();
  if (!id) return null;

  const typeRaw = raw.type;
  if (typeRaw !== "percentage" && typeRaw !== "amount") return null;

  const valueNum =
    typeof raw.value === "number"
      ? raw.value
      : parseFloat(String(raw.value ?? ""));
  if (Number.isNaN(valueNum)) return null;

  return {
    id,
    active: raw.active === true,
    type: typeRaw,
    name: name || id,
    value: valueNum,
    startsAt:
      raw.startsAt != null && raw.startsAt !== ""
        ? timestampFromCallableField(raw.startsAt)
        : Timestamp.fromMillis(0),
    expiresAt:
      raw.expiresAt != null && raw.expiresAt !== ""
        ? timestampFromCallableField(raw.expiresAt)
        : Timestamp.fromMillis(0),
    createdAt:
      raw.createdAt != null && raw.createdAt !== ""
        ? timestampFromCallableField(raw.createdAt)
        : Timestamp.now(),
  };
}
